module.exports = __webpack_public_path__ + "static/img/crandell.b3c9097.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/members/crandell.jpg
// module id = mxIf
// module chunks = 1